/**
 * Storefront display for a car's year, optionally prefixed with the 2-digit
 * registration month → "MM/YYYY". Falls back to the bare year when no month
 * is recorded, or to `fallback` when there is no year at all.
 *
 * The underlying `year` stays a standalone number used for filtering/sorting
 * (Meilisearch, catalog sort) — this helper only governs how the year is
 * *rendered* across catalog cards, the detail page, print sheets and the
 * QR-landing pages, so all surfaces show the same value.
 *
 * @param {{ year?: number|string, registrationMonth?: number|string|null }} [car]
 * @param {string} [fallback='']  shown when `year` is missing
 * @returns {string}
 */
export function formatRegYear(car, fallback = '') {
  const year = car?.year;
  if (year == null || year === '') return fallback;

  const month = Number(car?.registrationMonth);
  if (Number.isInteger(month) && month >= 1 && month <= 12) {
    return `${String(month).padStart(2, '0')}/${year}`;
  }
  return String(year);
}
